module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map-key"
    }
  }, [_c('div', {
    staticClass: "map-key-years"
  }, _vm._l((_vm.periodLoop), function(i, index) {
    return _c('div', {
      staticClass: "map-key-year",
      class: {
        current: i.checked, always: _vm.alwaysChecked
      },
      on: {
        "click": function($event) {
          _vm.checkYear(index)
        }
      }
    }, [_c('div', {
      staticClass: "map-key-checkbox"
    }), _vm._v(" "), _c('div', {
      staticClass: "map-key-period",
      domProps: {
        "innerHTML": _vm._s(i.display)
      }
    })])
  })), _vm._v(" "), (_vm.section.section === "urban-extent") ? _c('div', {
    staticClass: "cursor showLayers",
    on: {
      "click": function($event) {
        _vm.extraLayersVisible = !_vm.extraLayersVisible
      }
    }
  }, [_vm._v(_vm._s(_vm.extraLayersVisible ? 'Hide' : 'Show') + " Urban Composition")]) : _vm._e(), _vm._v(" "), (_vm.extraLayersVisible) ? _c('div', {
    staticClass: "map-key-layers "
  }, _vm._l((_vm.layersFiltered), function(layer, index) {
    return _c('div', {
      staticClass: "layer-action cursor",
      class: {
        'no-click': _vm.section.section === 'blocks-and-plots'
      },
      on: {
        "click": function($event) {
          _vm.checkLayer(index, layer)
        }
      }
    }, [_c('div', {
      staticClass: "layer-checkbox",
      style: (_vm.layerStyle(layer))
    }), _vm._v(" "), _c('div', {
      staticClass: "layer-title",
      domProps: {
        "innerHTML": _vm._s(layer.display)
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "satellite",
    on: {
      "click": _vm.switchBG
    }
  }, [_c('div', {
    class: {
      selected: !_vm.light
    }
  }, [_vm._v("Satellite")]), _c('div', {
    class: {
      selected: _vm.light
    }
  }, [_vm._v("Light")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f06182c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mapkey.vue
// module id = 296
// module chunks = 1